export default [
  {
    title: 'breadcrumb.chatPartner',
    route: 'chat-partner',
    icon: 'AirplayIcon',
    resource: 'chatPartner',
    action: 'read',
    tag: 0,
    tagVariant: "danger",
    isHasMessage: false,
  },
];